import type { ReactNode } from "react";

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter as DialogFooterPrimitive,
  DialogHeader as DialogHeaderPrimitive,
} from "./Dialog";

export type ModalProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
  /** When true, overlay clicks and Escape key won't close the modal. */
  preventDismiss?: boolean;
  /** Hide the built-in close (X) button. */
  hideCloseButton?: boolean;
};

export function Modal({
  open,
  onClose,
  children,
  className = "",
  preventDismiss = false,
  hideCloseButton = false,
}: ModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <DialogContent
        className={className}
        showCloseButton={!hideCloseButton}
        onInteractOutside={preventDismiss ? (e) => e.preventDefault() : undefined}
        onEscapeKeyDown={preventDismiss ? (e) => e.preventDefault() : undefined}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}

export function ModalHeader({ children, subtitle }: { children: ReactNode; subtitle?: string }) {
  return <DialogHeaderPrimitive subtitle={subtitle}>{children}</DialogHeaderPrimitive>;
}

export function ModalBody({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return <DialogBody className={className}>{children}</DialogBody>;
}

export function ModalFooter({ children }: { children: ReactNode }) {
  return <DialogFooterPrimitive>{children}</DialogFooterPrimitive>;
}
